import { Link } from "react-router-dom";

// A real, invisible <a> stretched to fill its nearest `position:relative`
// ancestor (a <td>, or a tree-row <div>) — right-click, middle-click, and
// ctrl/cmd-click all get the browser's OWN, FULL, unmodified context menu
// and new-tab/new-window handling for free, because there's a genuine
// <a href> under the cursor. A plain left click is intercepted so it opens
// the SidePanel via SPA state (today's fast, no-reload behavior) instead
// of a full page navigation; every modified click is left alone so the
// browser's own new-tab/new-window handling still fires.
//
// One per cell/row is fine — it has no visible rendering (no background,
// no border), so stacking several doesn't change anything on screen. Kept
// out of the tab order and hidden from assistive tech: it's a redundant
// hit-target duplicating the row's own visible text, which already reads
// fine in normal document order, and the row it replaces (`<tr onClick>`)
// had no keyboard support to begin with — this doesn't regress that.
export default function RowLink({ to, onActivate }) {
  return (
    <Link
      to={to}
      className="absolute inset-0"
      tabIndex={-1}
      aria-hidden="true"
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        onActivate();
      }}
    />
  );
}
